import { Box, type BoxProps } from '@mui/material';
import { isEmpty } from 'lodash';
import type { FC } from 'react';

export const SlabCardBody: FC<BoxProps> = ({ children, sx, ...props }) => {
  if (isEmpty(children)) return null;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, p: 2, ...sx }} {...props}>
      {children}
    </Box>
  );
};
